<template>
  <div class="carousel">
    <div style="margin-bottom:40px;" v-for="(item, index) in list" :key="index">
      <el-card shadow="never">
        <div class="header-flex">
          <h1 class="title">轮播图{{ index + 1 }}</h1>
          <span class="notice">(建议比例750:400,文件大小不得超过2MB)</span>
          <div class="flex-right">
            <i
              class="el-icon-close circle-close"
              @click="deleteCarousel(item, index)"
            ></i>
          </div>
        </div>

        <el-form label-position="top" label-width="80px" :model="item">
          <!-- <el-form-item label>
            <el-input v-model="item.url" clearable placeholder="轮播图地址"></el-input>
          </el-form-item>-->
          <el-form-item label>
            <div
              v-if="item.pic_path"
              class="previewAvatar"
              @mouseover="previewAvatar = true"
              @mouseout="previewAvatar = false"
              :class="{ previewAvatarHover: previewAvatar }"
            >
              <div>
                <i
                  class="el-icon-zoom-in icon-size"
                  v-show="previewAvatar"
                  @click="handlePictureCardPreview(item.pic_path)"
                ></i>
                <i
                  class="el-icon-delete icon-size"
                  v-show="previewAvatar"
                  @click="handlePictureDelete(index, item)"
                ></i>
              </div>
            </div>
            <el-upload
              class="avatar-uploader"
              :action="uploadAction"
              :data="uploadToken"
              :show-file-list="false"
              :accept="uploadAccept"
              :on-error="handleAvatarError"
              :on-success="
                (res, file, fileList) =>
                  handleAvatarSuccess(res, file, fileList, index)
              "
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="item.pic_path"
                :src="imgUrl + item.pic_path"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label>
            <quill-editor
              class="quill-editor"
              v-model="item.desc"
              :options="editorOption"
            ></quill-editor>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div style="display:flex;">
      <el-button type="primary" @click="onSubmit">确认提交</el-button>
      <el-button @click="addCarousel">添加轮播图</el-button>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="`${imgUrl + dialogImageUrl}`" alt />
    </el-dialog>
  </div>
</template>

<script>
import { carouselList, saveCarousel, delCarousel } from "@/api/setting";
import { quillEditor } from "vue-quill-editor";
import imgSize from "@/utils/imgSize";
import { quillRedefine } from "vue-quill-editor-upload";
export default {
  name: "carousel",
  data() {
    return {
      list: [],
      dialogImageUrl: "",
      dialogVisible: false,
      filelist: [],
      previewAvatar: false,
      uploadToken: {
        // 图片上传附带的token参数
        token: this.$store.getters.userinfo.login_token,
      },
      editorOption: {},
    };
  },
  components: {
    quillEditor,
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
    this.editorOption = quillRedefine({
      // 图片上传的设置
      uploadConfig: {
        action: this.uploadAction, // 必填参数 图片上传地址
        start: () => {
          this.$message({
            message: "正在上传,请稍候...",
            duration: 0,
            showClose: true,
            type: "info",
          });
        },
        end: () => {
          this.$message.closeAll();
          this.$message.success("上传成功!");
        },
        res: (respnse) => {
          if (respnse.code == 402) {
            this.$router.replace("login");
          }
          return respnse.data.files[0].full_path;
        },
        token: this.$store.getters.userinfo.login_token,
        size: 10240,
        name: "img", // 图片上传参数名
      },
    });
  },
  mounted() {
    this.getData();
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      carouselList().then((res) => {
        this.list = res.data;
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
    /**
     * 图片上传成功
     * @param {object} res - 请求响应数据 http的response
     * @param {object} file - 当前的文件
     * @param {array} fileList - 文件列表
     * @param {number} index - 下标
     */
    handleAvatarSuccess(res, file, fileList, index) {
      this.$message.closeAll();
      if (res.code == 200) {
        const { path, filename } = res.data.files[0];
        this.list[index].pic_path = path + filename;
      } else if (res.code == 402) {
        this.$message.error("未登录");
        this.$router.replace("login");
      }
    },
    /**
     * @param {object} - res 响应内容
     */
    handleAvatarError(res) {
      this.$message.closeAll();
      this.$message.error("上传失败" + res);
    },
    /**
     * 预览图片
     * @param {string} url - 图片地址
     */
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    /**
     * 删除图片
     * @param {number} index - 下标
     * @param {object} item - 列表项
     */
    handlePictureDelete(index) {
      this.list[index].pic_path = "";
    },
    /**
     * 图片上传之前
     * @param {object} file - 提交的文件
     */
    beforeAvatarUpload(file) {
      const isSize = imgSize(file, this);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不得超过2MB!");
      }
      isSize.then(() => {
        this.$message({
          showClose: true,
          duration: 0,
          message: "正在上传，请稍后...",
        });
      });
      return isLt2M && isSize;
    },
    /**
     * 确认提交
     */
    onSubmit() {
      saveCarousel({
        list: this.list,
      }).then(() => {
        this.$message.success("保存成功!");
        this.getData();
      });
    },
    /**
     * 删除轮播图
     * @param {object} item - 列表项
     * @param {number} index - 下标
     */
    deleteCarousel(item) {
      this.$confirm(`是否要删除该轮播图?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delCarousel({
          id: item.id,
        }).then(() => {
          this.$message.success("删除成功!");
          this.getData();
        });
      });
    },
    /**
     * 添加轮播图
     */
    addCarousel() {
      this.list.push({
        desc: "",
        id: 0,
        pic_path: "",
        url: "",
      });
      this.$message.success("添加成功");
    },
  },
};
</script>

<style scoped src="@/assets/css/avatorUploader.css"></style>
<style scoped src="./style/index.css"></style>
